var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.existsRole('gestor-financeiro'))?_c(_setup.AlertsTable,{staticClass:"mb-4"}):_vm._e(),_c(_setup.Painel)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }